import { render, staticRenderFns } from "./CreacionDeAvatar.vue?vue&type=template&id=b189f0e8&scoped=true"
import script from "./CreacionDeAvatar.vue?vue&type=script&lang=js"
export * from "./CreacionDeAvatar.vue?vue&type=script&lang=js"
import style0 from "./CreacionDeAvatar.vue?vue&type=style&index=0&id=b189f0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b189f0e8",
  null
  
)

export default component.exports